import { apiClient } from './api'
import type {
  IngestionRun,
  IngestionRunStart,
  IngestionIssuesResponse,
  ProcessableCollection,
  StartIngestionInput,
} from '../types/ingestion'

export interface ListIngestionIssuesParams {
  severity?: string
  artefactType?: string
}

export interface FlagCorruptParams {
  caseId: string
  runId: string
  reason: string
}

export async function listProcessableCollections(caseId: string): Promise<ProcessableCollection[]> {
  return apiClient.get<ProcessableCollection[]>(`/cases/${caseId}/processable-collections`)
}

export async function startIngestionRun(
  caseId: string,
  input: StartIngestionInput
): Promise<IngestionRunStart> {
  return apiClient.post<IngestionRunStart>(`/cases/${caseId}/ingestion-runs`, input)
}

export async function listIngestionRuns(caseId: string, status?: string): Promise<IngestionRun[]> {
  const query = status ? `?status=${status}` : ''
  return apiClient.get<IngestionRun[]>(`/cases/${caseId}/ingestion-runs${query}`)
}

export async function getIngestionRun(caseId: string, runId: string): Promise<IngestionRun> {
  return apiClient.get<IngestionRun>(`/cases/${caseId}/ingestion-runs/${runId}`)
}

export interface ListIngestionIssuesInput {
  caseId: string
  runId: string
  params?: ListIngestionIssuesParams
}

export async function listIngestionIssues(
  input: ListIngestionIssuesInput
): Promise<IngestionIssuesResponse> {
  const searchParams = new URLSearchParams()
  if (input.params?.severity) searchParams.set('severity', input.params.severity)
  if (input.params?.artefactType) searchParams.set('artefact_type', input.params.artefactType)
  const query = searchParams.toString() ? `?${searchParams.toString()}` : ''
  return apiClient.get<IngestionIssuesResponse>(
    `/cases/${input.caseId}/ingestion-runs/${input.runId}/issues${query}`
  )
}

export async function verifyIngestionRun(caseId: string, runId: string): Promise<IngestionRun> {
  return apiClient.put<IngestionRun>(`/cases/${caseId}/ingestion-runs/${runId}/verify`, {})
}

export async function flagIngestionCorrupt(params: FlagCorruptParams): Promise<IngestionRun> {
  return apiClient.put<IngestionRun>(
    `/cases/${params.caseId}/ingestion-runs/${params.runId}/flag-corrupt`,
    { reason: params.reason }
  )
}
